module.exports = __webpack_public_path__ + "c197b30aaaa383375f08c72ebd06823e.MP3";